import { LoaderCircle } from 'lucide-react';
import { classNames } from '../../utils/classNames';

function LoadingSpinner({ label = 'Cargando', size = 'md', className }) {
  const sizes = { sm: 'size-4', md: 'size-7', lg: 'size-10' };
  return (
    <span className={classNames('inline-flex items-center gap-2 text-sm text-content-muted', className)} role="status">
      <LoaderCircle className={classNames('animate-spin text-primary-600', sizes[size])} aria-hidden="true" />
      {label && <span>{label}</span>}
    </span>
  );
}

export default LoadingSpinner;
